module.exports = __webpack_public_path__ + "images/柏纳长图_06-2.jpg?v=2497b69b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_06-2.jpg
 ** module id = 146
 ** module chunks = 1 2
 **/